import { Injectable } from '@angular/core';
import { AppleWifiProfilePresetsService } from '@rocksoft/mdm-sdk-v2';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { WifiProfileApiActions, WifiProfileResolverActions } from './wifi-profile.actions';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class WifiProfileEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: AppleWifiProfilePresetsService
  ) {}

  loadSettingsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WifiProfileResolverActions.profilesRequested),
      mergeMap(() =>
        safeMap(
          this.api.getWifiProfilePresets('2.0'),
          (profiles) => WifiProfileApiActions.profilesLoaded({ profiles }),
          (error) => WifiProfileApiActions.profilesLoadedError({ error })
        )
      )
    );
  });
}
